<template lang="pug">
div
  .form-field-label
    span {{ label }}
    span.form-field-require-tag(v-show="required", :title="notifies.required_field")
      | *

  div(:class="[currentFieldIsInvalid ? main_class + ' valid-error' : main_class]")
    q-input(
      filled,
      no-error-icon,
      v-model="currentField",
      :label="placeholder ? placeholder : ''",
      autocomplete="off",
      :for="name",
      :class="{ 'with-label': !!placeholder }",
      type="textarea",
      ref="inputField",
      autogrow
    )
      q-icon.cancel-string-field(name="cancel", v-if="currentField", @click.stop="resetField()")

  .valid-error-message(v-if="currentFieldIsInvalid") {{ currentErrorMessage }}
</template>

<script>
import { useEmitter } from "@/services/useEmitter";
import { handleError } from "@/services/handleErrors";

export default {
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      method: this.parentData.method,
      method_limit: this.parentData.method_limit,
      grid: this.parentData.grid,
      value: this.parentData.data[0].value,
      label: this.parentData.data[0].label,
      placeholder: this.parentData.data[0].placeholder,
      name: this.parentData.data[0].name,
      depend_from: this.parentData.data[0].depend_from || {},
      watch: this.parentData.data[0].watch || {},
      req: this.parentData.data[0].require,
      rules: this.parentData.data[0].rules,
      valid_error_message: null,
      main_class: "form-field form-input expanded-string-field",
      itemId: this.parentData.item_id,
      emitter: useEmitter(),
    };
  },

  computed: {
    required: {
      get() {
        return this.req;
      },
      set(value) {
        this.req = value;
      },
    },

    currentField: {
      get() {
        let form_field = this.currentForm[this.name];
        if (form_field) {
          return form_field["field"];
        } else {
          return undefined;
        }
      },
      set(value) {
        let result = {};

        if (this.name !== "external_id") {
          if (value && value.length > 0) {
            result["field"] = value;
            result["invalid"] = this.invalid(value);
          } else {
            result["invalid"] = this.invalid();
          }
        } else {
          // Проверка на валидность поля external_id осуществляетася отдельным запросом на бек ниже
          result["field"] = value;
        }

        this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });

        const watchParentsLength = this.watch?.parents?.length;
        const watchParentsParamsAction = this.watch?.parents?.[0].parent_params?.action;

        if (watchParentsLength > 0 && watchParentsParamsAction === "/external_id_uniqueness") {
          // Проверяем есть ли в сторе поле родителя, чтобы исключить срабатывание до его инициализации
          const parentName = this.watch.parents[0]?.parent;
          const gridFormFromParentName = this.$store.state.grid[this.grid].form[parentName];

          if (gridFormFromParentName) {
            const gridPath = `${this.$store.state.paths[this.watch.parents[0].parent_params.path]}`;
            const additionalPath = watchParentsParamsAction;
            const path = `${gridPath}/${additionalPath}`;
            const params = {
              [parentName]: this.getFieldValuesByName(parentName),
              [this.name]: this.currentField,
              material_id: this.itemId,
            };
            this.checkExternalIdUnic(path, params);
          }
        }

        if (!result["invalid"] && this.name !== "external_id") {
          this.$store.commit("resetFormFieldValue", {
            grid_name: this.grid,
            field: "invalid_fields",
            value: this.name,
          });
        }
      },
    },

    fieldDependency() {
      return this.checkDependency();
    },

    // Errors messages we set from backend
    customErrorMessage() {
      const invalidFieldsErrors = this.currentForm.invalid_fields_errors;

      if (!invalidFieldsErrors) {
        return "";
      }

      return invalidFieldsErrors[this.name];
    },

    // Order of fields is important: valid_error_message must be first to preserve required errors
    currentErrorMessage() {
      return this.valid_error_message || this.customErrorMessage;
    },
  },
  watch: {
    fieldDependency(newVal, oldVal) {},
  },

  created() {
    this.watchSimpleFieldParents();
  },

  beforeMount() {
    this.emitter.on("allFieldsLoaded", this.textAreaAdjust);
    this.$store.commit("createFormField", { grid_name: this.grid, field: this.name });
    this.setField(this.value);
  },

  beforeDestroy() {
    this.emitter.off("allFieldsLoaded", this.textAreaAdjust);
  },

  methods: {
    textAreaAdjust() {
      setTimeout(() => {
        const el = this.$refs.inputField.$el.querySelector("textarea");
        el.style.height = "1px";
        el.style.height = el.scrollHeight + "px";
      }, 0);
    },

    setField(val) {
      this.currentField = val;
    },

    setRequire(val) {
      this.required = val;
      let result = {};
      result["field"] = this.currentField;
      result["invalid"] = this.invalid(this.currentField);
      this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });

      this.$store.commit("resetFormFieldValue", {
        grid_name: this.grid,
        field: "invalid_fields",
        value: this.name,
      });
    },

    resetField() {
      this.currentField = "";
    },

    invalid(val = undefined) {
      let result;

      if (this.required) {
        if (val && val.length > 0) {
          this.valid_error_message = null;
          result = false;
        } else {
          this.valid_error_message = this.notifies.not_empty;
          result = true;
        }
      } else {
        this.valid_error_message = null;
        result = false;
      }

      if (this.rules && this.rules.length > 0) {
        if (val && val.length > 0) {
          let messages = this.rules
            .map(rule => {
              let regex = new RegExp(rule["regex"]);
              if (!regex.test(val)) {
                return rule["error"];
              }
            })
            .filter(msg => ![undefined, null, ""].includes(msg));
          if (messages.length > 0) {
            this.valid_error_message = messages[messages.length - 1];
            result = true;
          }
        }
      }

      return result;
    },

    checkExternalIdUnic: _.debounce(async function (path, params) {
      try {
        const { data } = await this.$backend.index(path, { params });
        this.setFieldInvalid(data);
      } catch (err) {
        // Не используем handleError, т.к. он выведет всплывающее оповещение с ошибкой, а нам это не нужно
        const error = err?.response?.data?.errors;
        this.setFieldInvalid(error);
        await handleError(err, { notify: false });
      }
    }, 500),

    getFieldValuesByName(name) {
      const storeField = this.currentForm[name]?.field;
      return storeField.map(item => item?.value);
    },

    setFieldInvalid(err) {
      const result = {};
      result.field = this.currentField;

      if (err && this.currentField !== this.value) {
        result.invalid = true;
        this.valid_error_message = err;
      } else {
        result.invalid = false;
        this.valid_error_message = null;

        this.$store.commit("resetFormFieldValue", {
          grid_name: this.grid,
          field: "invalid_fields",
          value: this.name,
        });
      }

      this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/styles/forms/fields/string";

.with-label {
  .q-field__label {
    margin-top: -9px !important;
  }
  input {
    margin-top: 9px !important;
  }
}

.valid-error-message {
  position: static;
}

:deep(.expanded-string-field) {
  .q-field {
    padding-bottom: 2px;
  }
  .q-field .q-field__inner .q-field__control {
    height: auto !important;
  }
  .q-field__native {
    padding-top: 10px;
  }
  textarea {
    padding-right: 25px !important;
    overflow: hidden;
    color: var(--field-input-color);
  }
  .q-textarea .q-field__control {
    min-height: unset !important;
  }
}
</style>
